import React, { useEffect } from "react";

const headingStyle = {
  fontSize: "1.15rem",
  fontWeight: 600,
  marginTop: "1.75rem",
  marginBottom: "0.5rem",
};

export default function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container py-5">
      <h1 className="cs-section_title text-center mb-3">Privacy Policy</h1>
      <p className="text-center mb-5">
        <strong>Last Updated:</strong> 05.05.2026
      </p>

      <p>
        Charles Technologies Pvt. Ltd. (&ldquo;we,&rdquo; &ldquo;our,&rdquo;
        &ldquo;us&rdquo;) operates this website to share information about our
        company. We design and build internal business applications for
        entities of the Charles Group; we do not offer consumer products or
        services through this website and do not knowingly collect personal
        information from visitors.
      </p>
      <p>
        This Privacy Policy explains the limited information that may be
        gathered when you browse the site and how we handle it. By using the
        website you agree to this policy. If you do not agree, please
        discontinue use.
      </p>

      <h3 style={headingStyle}>1. Information We Do Not Collect</h3>
      <p>
        Our website does not require registration, login, or the submission of
        personal data to access its content. We do not sell, rent, or trade any
        information.
      </p>

      <h3 style={headingStyle}>2. Information Automatically Collected</h3>
      <p>
        Like most websites, our hosting provider may automatically log basic
        technical information such as IP address, browser type, device type,
        referring page, and pages visited. This information is used solely to
        operate the site, maintain security, and understand aggregate traffic.
        It is not used to identify individual visitors.
      </p>

      <h3 style={headingStyle}>3. Cookies</h3>
      <p>
        We may use a small number of essential or analytics cookies to keep the
        site functioning and to measure aggregate usage. You can disable
        cookies through your browser settings; the site will continue to work
        normally.
      </p>

      <h3 style={headingStyle}>4. Information You Voluntarily Provide</h3>
      <p>
        If you contact us by email or through any contact link on the site, we
        will receive the information you choose to share (such as your name,
        email address, and the content of your message). We use this only to
        respond to your enquiry and do not add it to any marketing list.
      </p>

      <h3 style={headingStyle}>5. Internal Business Applications</h3>
      <p>
        The internal applications we build are operated for and within the
        Charles Group and are governed by separate agreements and access
        controls. This website does not provide access to those applications,
        and any data within them is handled under the relevant
        engagement&rsquo;s terms, not this policy.
      </p>

      <h3 style={headingStyle}>6. Data Security</h3>
      <p>
        We use reasonable technical and organisational measures to protect any
        information transmitted through this website. No system is completely
        secure, and we cannot guarantee absolute protection.
      </p>

      <h3 style={headingStyle}>7. Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page and become effective upon posting.
      </p>

    </div>
  );
}
